import { Component, OnInit, Inject } from '@angular/core';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatDialog } from "@angular/material/dialog";
import { ConfiguratorComponentComponent } from "../configurator-component/configurator-component.component";
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-define-eboiler',
  templateUrl: './define-eboiler.component.html',
  styleUrls: ['./define-eboiler.component.scss'],
  standalone: true,
  imports: [FormsModule,NgbModule,CommonModule]
})
export class DefineEboilerComponent implements OnInit {
private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
public getGnericSerialNo = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
private  allSitesUrl = BaseUrlConstantsService.GET_SITES;
public addSubsystem = BaseUrlConstantsService.eBoilerRoomApi;
public gatewayAdresses = BaseUrlConstantsService.eBoilerRoomApi;
public newgenericSerialNo: string;
public genericSerialNo: string;
public sitesList:any =[];
public showList: boolean;
public emptyMsg: boolean;
public userRoll: string;
public applicationList: any;
public selectedApplication: any;
public selectedSite: any;
public selectedgateway: any;
public boilerName: string;
public clientId: any;
  subsystemId: any;
  siteName: any;
  applicationName: any;
  public gatewayAddressesList: any =[];
  gateway_inventory_id: any;
  constructor(private service: BackendApiService, 
    @Inject(MAT_DIALOG_DATA) public data : {client_id:any , product_type_id: any}, 
    public router: Router, public dialogRef: MatDialogRef<DefineEboilerComponent>) {

     }

  ngOnInit(): void {
    this.clientId = localStorage.getItem('user_id');
    this.userRoll = localStorage.getItem('role');
    this.getGatewayAddress();
    this.getallSitesAndGroupsInfo(this.data.client_id);
    console.log(this.selectedSite,'selected site',)
    this.getPreviousSerialNo();
  }
  getallSitesAndGroupsInfo(clientid) {
    this.service.getData(this.allSitesUrl + "/" + Math.floor(Math.random() * 90 + 10) + clientid + Math.floor(Math.random() * 9000 + 1000)).then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        if(JSON.parse(JSON.stringify(res)).data.body.length !== 0){
          this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
        }else {
          this.service.showError("Something went wrong.");
        }
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }
//get application
  async getGroupsBySiteId(siteId: any) {
    let body;
    if (this.userRoll === "USER") {
      body = {
        client_id: localStorage.getItem("client_id"),
        user_id: localStorage.getItem("user_id"),
        site_id: siteId,
      };
    } else {
      body = {
        client_id: localStorage.getItem("user_id"),
        site_id: siteId,
      };
    }
    this.service
      .getData(
        this.getApplicationsUrl +
        "/" +
        localStorage.getItem("user_id") +
        "/" +
        siteId
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
            this.applicationList = JSON.parse(JSON.stringify(res)).data.body;
          } else {
           
          }
        } else {
          this.service.showError("Something went wrong.");
        }
      });
  }

  onClose(){
    this.dialogRef.close();

  }

  isFormValid() {
    return this.boilerName && this.selectedSite && this.selectedApplication && this.selectedgateway;
  }

onSiteSelected(siteId){
  this.getGroupsBySiteId(siteId);
}

//add subsystem
  addSubsystemFun(){
    const body = {
      "type":"custom-TBoiler",
      "name": this.boilerName,
      "site_id": this.selectedSite,
      "mac_address" : this.selectedgateway,
      "inventory_id": this.gateway_inventory_id,
      "application_id": this.selectedApplication,
      "client_id": this.clientId,
      "product_type_id": this.data['product_type_id'],
      "device_sno" : this.newgenericSerialNo
    }
    this.dialogRef.close();
    this.service.postData(`${this.addSubsystem}eboiler/add`,body)
    .then(res =>{
      let response = JSON.parse(JSON.stringify(res)).data;
      if(response.status === 'success'){
        this.subsystemId = response.id;
        this.boilerName = response.name;
        this.siteName = response.siteName;
        this.applicationName = response.applicationName;
        this.router.navigate(['boiler-configurator'],{queryParams:{subsystem_id:this.subsystemId, boilerName: this.boilerName, device_sno: this.newgenericSerialNo, site_name: this.siteName, application_name: this.applicationName }});
      }else{
          this.service.showError("Something went wrong.");
      }
      
    });
  }

  //get gateway address

  getGatewayAddress(){
    this.service.getData(this.gatewayAdresses + "gateway_address/" + Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000))
    .then(res => {
      let response = JSON.parse(JSON.stringify(res)).data;
      console.log(response,'dddddddddddddseeeeeeeeeeeeeee')
      if(response.status === "success"){
        if(response.body.length != 0){
          this.gatewayAddressesList = response.body;
        }
      }
    })
  }

  getPreviousSerialNo(){
    console.log(this.data['product_type_id'])
      this.service.getData(`${this.getGnericSerialNo}generic_asset/${this.data['product_type_id']}`)
      .then((res:any) =>{
        let response = res.data;
        if(response.status === "success"){
            if(response.body?.body?.length === 0){
              this.genericSerialNo = "";
            }else{
              this.genericSerialNo = response.body.device_sno;
            }
        }else{
          this.genericSerialNo = "";
        }
      })
  }

   onGatewayChange(event: any) {
    console.log(event.target)
      const selectedMac = event.target.value; // just the MAC string
      const selectedGateway = this.gatewayAddressesList.find(
        g => g.mac_address === selectedMac
      );
      this.gateway_inventory_id = selectedGateway.id;
      console.log(this.gateway_inventory_id)
      let selectedAbbr = selectedGateway.abbreviation;
      if (!this.genericSerialNo || this.genericSerialNo === "") {
        // First time → start fresh
        this.genericSerialNo = selectedAbbr + "BA01";
      } else {
        // Example current: RIOA01 → want only prefix(2) + letter + number
        let letter = this.genericSerialNo.charAt(this.genericSerialNo.length - 3); // "A"
        let number = parseInt(this.genericSerialNo.slice(-2), 10);                 // 01

        if (number < 99) {
          number++;
          this.genericSerialNo =
            selectedAbbr +"B  "+ letter + number.toString().padStart(2, "0");
        } else {
          // rollover case: XX...A99 → XX...B01
          let nextLetter = String.fromCharCode(letter.charCodeAt(0) + 1);
          this.genericSerialNo = selectedAbbr +"B"+ nextLetter + "01";
        }
      }
      this.newgenericSerialNo = this.genericSerialNo;
      console.log("Updated Serial:", this.newgenericSerialNo);
  }
}
